import React from 'react';

//This component lists all the information to be known for physics.


const sub1 = {
  paddingLeft: 10,
  textAlign: 'left'
}



class AAMCReq extends React.Component{
  render(){
    return(
      <div>

      <div class = "title"> Translational Motion
      <div class = "topics">
        Units and dimensions <br/>
        Vectors, components <br/>
        Vector addition <br/>
        Speed, velocity (average and instantaneous) <br/>
        Acceleration
      </div>
    </div>

      <div class = "title"> Force
        <div class = "topics">
          Newton’s First Law, inertia <br/>
          Newton’s Second Law <br/>
          Newton’s Third Law, forces equal and opposite <br/>
          Friction, static and kinetic <br/>
          Center of mass <br/>
        </div>
      </div>

      <div class = "title"> Equilibrium
        <div class = "topics">
          Vector analysis of forces acting on a point object <br/>
          Torques, lever arms
        </div>
      </div>

      <div class = "title"> Work
        <div class = "topics">
          Work done by a constant force: W = Fd cosθ <br/>
          Mechanical advantage <br/>
          Work Kinetic Energy Theorem <br/>
          Conservative forces
        </div>
      </div>

      <div class = "title"> Energy of Point Object Systems
        <div class = "topics">
          Kinetic Energy: KE = ½ mv<sup>2</sup>; units <br/>
          Potential Energy: <br/>
          <div class = "sub1"> PE = mgh (gravitational, local) <br/>
           PE = ½ kx<sup>2</sup> (spring) </div>
          Conservation of energy <br/>
          Power, units
        </div>
      </div>

      <div class = "title"> Periodic Motion
      <div class = "topics">
        Amplitude, frequency, phase <br/>
        Transverse and longitudinal waves: wavelength and propagation speed
      </div>
      </div>

      <div class = "title"> Fluids
      <div class = "topics">
        Density, specific gravity <br/>
        Buoyancy, Archimedes’ Principle <br/>
        Hydrostatic pressure:
        <div class = "sub1"> Pascal’s Law <br/>
        Hydrostatic pressure; P = ρgh (pressure vs. depth) </div>
        Viscosity: Poiseuille Flow <br/>
        Continuity equation (A∙V = constant) <br/>
        Concept of turbulence at high velocities <br/>
        Surface tension <br/>
        Bernoulli’s equation <br/>
        Venturi effect, pitot tube
      </div>
      </div>

      <div class = "title"> Gas Phase
      <div class = "topics">
        Absolute temperature, (K) Kelvin Scale <br/>
        Pressure, simple mercury barometer <br/>
        Molar volume at 0°C and 1 atm = 22.4 L/mol <br/>
        Ideal gas: <br/>
        <div class = "sub1">
          Definition <br/>
          Ideal Gas Law: PV = nRT <br/>
          Boyle’s Law: PV = constant <br/>
          Charles’ Law: V/T = constant <br/>
          Avogadro’s Law: V/n = constant
        </div>
        Kinetic Molecular Theory of Gases: <br/>
        <div class = "sub1">
          Heat capacity at constant volume and at constant pressure <br/>
          Boltzmann’s Constant
        </div>
        Deviation of real gas behavior from Ideal Gas Law: <br/>
        <div class = "sub1">
          Qualitative <br/>
          Quantitative (Van der Waals’ Equation) <br/>
        </div>
        Partial pressure, mole fraction <br/>
        Dalton’s Law relating partial pressure to composition
      </div>
      </div>

      <div class = "title"> Electrostatics
      <div class = "topics">
      Dalton’s Law relating partial pressure to composition <br/>
      Insulators <br/>
      Coulomb’s Law <br/>
      Electric field (E):
      <div class = "sub1">
        Field lines <br/>
        Field due to charge distribution
      </div>
      Electrostatic energy, electric potential at a point in space
      </div>
      </div>

      <div class = "title"> Circuit Elements
      <div class = "topics">
      Current I = ΔQ/Δt, sign conventions, units <br/>
      Electromotive force, voltage <br/>
      Resistance:
      <div class = "sub1">
        Ohm’s Law: I = V/R <br/>
        Resistors in series <br/>
        Resistors in parallel <br/>
        Resistivity: ρ = R•A / L
      </div>
      Capacitance: <br/>
      <div class = "sub1">
        Parallel plate capacitor <br/>
        Energy of charged capacitor <br/>
        Capacitors in series <br/>
        Capacitors in parallel <br/>
        Dielectrics <br/>
      </div>
      Conductivity:
      <div class = "sub1">
        Metallic <br/>
        Electrolytic
      </div>
      Meters
      </div>
      </div>

      <div class = "title"> Magnetism
      <div class = "topics">
      Definition of magnetic field (B) <br/>
      Motion of charged particles in magnetic fields; Lorentz force
      </div>
      </div>

      <div class = "title"> Sound
      <div class = "topics">
      Production of sound <br/>
      Relative speed of sound in solids, liquids, and gases <br/>
      Intensity of sound, decibel units, log scale <br/>
      Attenuation (Damping) <br/>
      Doppler Effect: moving sound source or observer, reflection of sound from a moving object <br/>
      Pitch <br/>
      Resonance in pipes and strings <br/>
      Ultrasound <br/>
      Shock waves
      </div>
      </div>

      <div class = "title"> Light, Electromagnetic Radiation
      <div class = "topics">
      Concept of Interference; Young Double-slit Experiment <br/>
      Thin films, diffraction grating, single-slit diffraction <br/>
      Other diffraction phenomena, X-ray diffraction <br/>
      Polarization of light: linear and circular <br/>
      Properties of electromagnetic radiation:
      <div class = "sub1">
      Velocity equals constant c, <i> in vacuum </i> <br/>
      Electromagnetic radiation consists of perpendicularly oscillating electric and magnetic fields; direction of propagation is perpendicular to both
      </div>
      Classification of electromagnetic spectrum, photon energy E = hf <br/>
      Visual spectrum, color
      </div>
      </div>

      <div class = "title"> Geometrical Optics
      <div class = "topics">
      Reflection from plane surface: angle of incidence equals angle of reflection <br/>
      Refraction, refractive index n; Snell’s law: n1 sin θ1 = n2 sin θ2 <br/>
      Dispersion, change of index of refraction with wavelength <br/>
      Conditions for total internal reflection <br/>
      Spherical mirrors
      <div class = "sub1">
      Center of curvature <br/>
      Focal length <br/>
      Real and virtual images
      </div>
      Thin lenses
      <div class = "sub1">
      Converging and diverging lenses <br/>
      Use of formula 1/p + 1/q = 1/f, with sign conventions <br/>
      Lens strength, diopters
      </div>
      Combination of lenses <br/>
      Lens aberration <br/>
      Optical Instruments, including the human eye
      </div>
      </div>

      <div class = "title"> Atomic Nucleus
      <div class = "topics">
      Atomic number, atomic weight <br/>
      Neutrons, protons, isotopes <br/>
      Nuclear forces, binding energy <br/>
      Radioactive decay:
      <div class = "sub1">
      α, β, γ decay <br/>
      Half-life, exponential decay, semi-log plots
      </div>
      Mass spectrometer
      </div>
      </div>

      <div class = "title" style = {{paddingBottom: 50}}> Electronic Structure
      <div class = "topics">
      Orbital structure of hydrogen atom, principal quantum number n, number of electrons per orbital <br/>
      Ground state, excited states <br/>
      Absorption and emission line spectra <br/>
      Use of Pauli Exclusion Principle <br/>
      Paramagnetism and diamagnetism <br/>
      Conventional notation for electronic structure <br/>
      Bohr atom <br/>
      Heisenberg Uncertainty Principle <br/>
      Effective nuclear charge <br/>
      Photoelectric effect
      </div>
      </div>
    </div>

    );
  }
}

export default AAMCReq;



// WEBPACK FOOTER //
// ./src/Physics/AAMCReq/AAMCReq.js